import { render, staticRenderFns } from "./SnippetCarousel.vue?vue&type=template&id=0df84561&scoped=true"
import script from "./SnippetCarousel.vue?vue&type=script&lang=js"
export * from "./SnippetCarousel.vue?vue&type=script&lang=js"
import style0 from "./SnippetCarousel.vue?vue&type=style&index=0&id=0df84561&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df84561",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicImage: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicImage.vue').default,BasicVideo: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicVideo.vue').default})
